import { urlHome } from '@/urls';
import { Outlet, ScrollRestoration } from 'react-router';
import { Toaster } from 'sonner';

function CommonLayout() {
  return (
    <>
      <ScrollRestoration />
      <Toaster />
      <Outlet />
    </>
  );
}

export const route = {
  path: urlHome(),
  element: <CommonLayout />,
};
